import DapDSTable from './table.component'

export * from './table.component'
export default DapDSTable

DapDSTable.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-table': DapDSTable
  }
}
